// src/components/Banner.jsx
import React from "react";
import { useAdmin } from "../context/AdminProvider";

export default function Banner() {
  const { bannerText } = useAdmin();
  if (!bannerText) return null;
  return (
    <div className="w-full bg-accent text-neutral-900 text-center py-2 font-bold z-40">
      {bannerText}
    </div>
  );
}
